jQuery(function ($) {
    "use strict";
    $('#btn-open-mobile').on('click', function(e){
        e.preventDefault();
        $('#header-menu').css('right', 0);
    });
    $('#btn-close-mobile').on('click', function(e){
        e.preventDefault();
        $('#header-menu').css('right', -350);
    });
    $('#header-menu a').on('click', function(){
        $('#header-menu').css('right', -350);
    });
    $('.carrossel .gallery').slick({
        adaptiveHeight: true,
        centerMode: true,
        centerPadding: '-90px',
        slidesToShow: 3,
        slidesToScroll: 1,
        adaptiveHeight: false,
        arrows: true,
        dots: false,
        prevArrow: '<button type="button" class="slick-prev" aria-label="Voltar"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 15.73 18.162"><path d="M15.73 9.081V0L7.865 4.541 0 9.081l7.865 4.541 7.865 4.54z" fill="currentColor"/></svg></button>',
        nextArrow: '<button type="button" class="slick-next" aria-label="Próximo"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="18" viewBox="0 0 15.73 18.162"><path d="M-.004 9.081V0l7.865 4.541 7.865 4.54-7.865 4.541-7.865 4.54z" fill="currentColor"/></svg></button>',
        responsive: [
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                }
            }
        ]
    });
    /* =Mask jQuery
    -------------------------------------------------------------- */
    $('.mask-date').mask('00/00/0000');
    $('.mask-time').mask('00:00:00');
    $('.mask-dateTime').mask('00/00/0000 00:00:00');
    $('.mask-cep').mask('00.000-000');
    $('#calc_shipping_postcode').mask('00000-000');
    $('.mask-cpf').mask('000.000.000-00');
    $('.mask-cnpj').mask('00.000.000/0000-00');
    $('.mask-money').mask('000.000.000.000.000,00', { reverse: true });
    var CelMaskBehavior = function (val) {
        return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009';
    },
        celOptions = {
            onKeyPress: function (val, e, field, options) {
                field.mask(CelMaskBehavior.apply({}, arguments), options);
            }
        };

    $('.mask-tel').mask(CelMaskBehavior, celOptions);

});